import { SavedSearch } from "../../../types/neighborhoodSearch";

/**
 * Determines if a saved search is a combined search
 * @param search - The saved search to check
 * @returns true if the search is a combined search, false otherwise
 */
export const isCombinedSavedSearch = (search: SavedSearch): boolean => {
  return !!search.search_parameters?.combinedSearchSources;
};